(() => {
  const selectService = (value) => {
    if (!value) return;
    document.querySelectorAll('[data-frostline-service-select]').forEach((select) => {
      const matchingOption = Array.from(select.options).find((option) => option.value === value || option.textContent.trim() === value);
      if (matchingOption) {
        select.value = matchingOption.value;
        select.dispatchEvent(new Event('change', { bubbles: true }));
      }
    });
  };

  const scrollToQuote = () => {
    const quote = document.getElementById('quote');
    if (quote) {
      quote.scrollIntoView({ behavior: 'smooth', block: 'start' });
      return true;
    }
    return false;
  };

  const applyPendingService = () => {
    const params = new URLSearchParams(window.location.search);
    const pending = params.get('service') || window.sessionStorage.getItem('frostlinePreferredService');
    if (pending) {
      selectService(pending);
      window.sessionStorage.removeItem('frostlinePreferredService');
    }
  };

  const initHeader = () => {
    const header = document.querySelector('[data-fl-header]');
    if (!header) return;

    const toggle = header.querySelector('[data-fl-menu-toggle]');
    const menu = header.querySelector('[data-fl-mobile-menu]');
    const closeMenu = () => {
      if (!toggle || !menu) return;
      toggle.setAttribute('aria-expanded', 'false');
      menu.hidden = true;
    };

    if (toggle && menu) {
      toggle.addEventListener('click', () => {
        const isOpen = toggle.getAttribute('aria-expanded') === 'true';
        toggle.setAttribute('aria-expanded', String(!isOpen));
        menu.hidden = isOpen;
      });

      menu.querySelectorAll('a').forEach((link) => link.addEventListener('click', closeMenu));
      document.addEventListener('keydown', (event) => {
        if (event.key === 'Escape') closeMenu();
      });
    }

    const setScrolledState = () => header.classList.toggle('is-scrolled', window.scrollY > 8);
    setScrolledState();
    window.addEventListener('scroll', setScrolledState, { passive: true });
  };

  const initQuoteLinks = () => {
    document.addEventListener('click', (event) => {
      const quoteLink = event.target.closest('[data-frostline-service]');
      if (!quoteLink) return;
      const service = quoteLink.dataset.frostlineService;
      if (!service) return;

      if (scrollToQuote()) {
        event.preventDefault();
        selectService(service);
        window.history.replaceState({}, '', `${window.location.pathname}${window.location.search}#quote`);
      } else {
        window.sessionStorage.setItem('frostlinePreferredService', service);
      }
    });
  };

  document.addEventListener('DOMContentLoaded', () => {
    initHeader();
    initQuoteLinks();
    applyPendingService();
  });
})();
